import { Validator } from './Validator';
import {ValidationResult, ValidationRuleConfig, ValidatorOptions} from '../types';

export class ValidatorBuilder {
    private data: Record<string, any> = {};
    private rules: Record<string, ValidationRuleConfig[]> = {};
    private options: ValidatorOptions = {};

    setData(data: Record<string, any>): this {
        this.data = data;
        return this;
    }

    addField(field: string, rules: ValidationRuleConfig[]): this {
        this.rules[field] = rules;
        return this;
    }

    setOptions(options: ValidatorOptions): this {
        this.options = options;
        return this;
    }

    setLanguage(language: string): this {
        this.options.language = language;
        return this;
    }

    build(): Validator {
        return new Validator(this.data, this.options);
    }

    validate(): ValidationResult {
        const validator = this.build();
        return validator.validateRules(this.rules);
    }
}